export abstract class ParserService<T> {
  public abstract parse(value: T): string;
  public abstract unparse(value: string, nullIfEmpty?: boolean): T;
}
